import axiosInst from '../../libs/axios/axios'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  filters: {
    user:null
  },
  apiary:null
}
const getters = {
  apiaryFilters (state) {
    return state.filters
  },
  apiaryData (state) {
    return state.apiary
  }
}
const mutations = {
  apiary (state, info) {
    state.apiary = info
  },
  filters (state, info) {
    if (info.type === 'user') {
      state.filters.user = info.data
    }
  }
}
const actions = {
  getApiaryFilters (store, filters) {
    store.commit('filters', filters)
  },
  getApiariesData (store, params) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/apiary/${  params}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getApiariesLazyLoadData (store, api) {
    return new Promise((resolve, reject) => {
      axiosInst.get(api).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async getApiarySelectBoxData (store, info) {
    try {
      const response = await axiosInst.get(`${state.rootUrl  }/api/apiary/${  info}`)
      const apiaryOptions = []
      if (response.data.results.length) {
        response.data.results.map((value) => {
          apiaryOptions.push({ label: value.name, value: value.id })
        })
      }
      return Promise.resolve({ options: apiaryOptions, next: response.data.next })
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getApiary (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/apiary/${  data.id}/`)
        .then(response => {
          store.commit('apiary', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  apiaryStatistics (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/apiary/${  data.id  }/statistics/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  createApiary (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/apiary/`,
        {
          name: data.name,
          country: data.country,
          city: data.city,
          state: data.state,
          created_at: data.created_at,
          lat: data.lat,
          lng: data.lng
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteApiary (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.delete(`${state.rootUrl  }/api/apiary/${  data.id  }/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editApiary (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/apiary/${  data.id  }/`, {
        name: data.name,
        country: data.country,
        city: data.city,
        state: data.state,
        lat: data.lat,
        lng: data.lng
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
